import { React, useEffect, useState } from 'react'
import { hostValue } from '../utils/Utils'
import DOMPurify from 'dompurify'
import { Markup } from 'react-render-markup'
import Header from './layout/Header'

const HTMLFragment = ({ componentPath }) => {
  const [text, setText] = useState('')
  const findLocation = window.location.href
  const currentYear = new Date().getFullYear().toString()

  const defaultHandler = () => {
    if (findLocation.includes('recruit') && text.includes('meta')) { // cdp only case
      return <Header></Header>
    } else {
      return <Markup markup={DOMPurify.sanitize(text)} />
    }
  }

  useEffect(() => {
    fetch(hostValue(findLocation) + componentPath)
      .then((response) => response.text())
      .then((md) => { setText(md.replace('{YEAR}', currentYear)) })
  }, [componentPath])

  // config target _blank
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if ('target' in node && node && node.classList && !node.classList.contains('clearSession')) {
      node.setAttribute('target', '_blank')
      node.setAttribute('rel', 'noopener noreferrer')
    }
  })

  return (
    <>{defaultHandler()}</>
  )
}

export default HTMLFragment
